import { useAuth } from '@/hooks/useAuth';
import { Spinner } from '@/components/Spinner';
import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react';

interface PublicOnlyRouteProps {
    children: ReactNode;
}

/**
 * Wraps routes that must NOT be visible to authenticated users
 * (e.g. /login, /register). Bounces back to `/` with replace so the
 * public page never sits in the history stack.
 */
const PublicOnlyRoute = ({ children }: PublicOnlyRouteProps) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <Spinner />;
    }

    if (user) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};


export default PublicOnlyRoute;